import { render, staticRenderFns } from "./Followee.vue?vue&type=template&id=a53b6ee0&"
import script from "./Followee.vue?vue&type=script&lang=js&"
export * from "./Followee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports